<template>
     <back-layout title="Candidatos">
        <template #header>
            <div class="flex justify-between px-4 flex-col sm:flex-row">
                <h2 class="font-semibold text-2xl lg:text-4xl text-gray-300 leading-tight mb-4 md:mb-0">Candidatos</h2>
            </div>
        </template>

        <!-- SEARCH BOX GOES HERE -->

        <div class="container mx-auto px-4">
            <div class="lg:flex lg:space-x-4">
                <div class="w-full">
                    <div v-if="candidatos && candidatos.length">
                    <div class="px-4 my-2 flex items-center uppercase text-xs font-bold justify-between">
                        <p class="flex-1">Nome</p>
                        <p class="flex-1 hidden md:block">Email</p>
                        <p class="flex-1">Tel</p>
                        <p class="flex-1">Localidade</p>
                        <p class="flex-1">Ações</p>
                    </div>
                    <div v-for="candidato in candidatos" class="bg-white overflow-hidden shadow rounded-lg p-4 my-2 flex items-center self-start space-x-2">
                        <Link :href="route('show.candidato', candidato.id)" class="flex-1 font-bold text-xs md:text-sm">{{ candidato.nome }}</Link>
                        <p class="flex-1 hidden md:block text-xs md:text-sm">{{ candidato.email }}</p>
                        <p class="flex-1 hidden md:block text-xs md:text-sm">{{ candidato.tel }}</p>
                        <p class="flex-1 hidden md:block text-xs md:text-sm">{{ candidato.localidade }}</p>
                        <div class="flex-1 flex flex-col space-y-2">
                            <jet-button @click.prevent="showCandidato(candidato.id)" class="flex justify-center py-1 px-2 text-xs rounded-full border border-gray-400 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-gray-400 focus:border-gray-400 focus:ring-transparent active:shadow-0 focus:shadow-0 text-gray-400 mr-2"><icon name="edit" class="w-3 h-3" /> Ver perfil</jet-button>

                            <jet-button @click.prevent="removerCandidato(candidato.id)" class="flex justify-center py-1 px-2 text-xs rounded-full border border-amber-600 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-amber-600 focus:border-amber-600 focus:ring-transparent active:shadow-0 focus:shadow-0 text-amber-600 mr-2"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
                        </div>
                    </div>
                    </div>
                    <div v-else class="text-center pt-20">
                        <em class="text-gray-400">Sem Candidatos</em>
                    </div>
                </div>
            </div>
        </div>
    </back-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import Icon from '@/Jetstream/Icon'
    import JetInput from '@/Jetstream/Input.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'


    export default defineComponent({
        components: {
            Head,
            Link,
            BackLayout,
            JetButton,
            Icon,
            JetInput,
            JetSecondaryButton,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            candidatos: Array,
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
            dateFormated(jobDate) {
                let date = new Date(jobDate)
                return date.toLocaleDateString()
            },
            showCandidato(candidato) {
                this.$inertia.get(route('show.candidato', candidato));
            },
            removerCandidato(candidato) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('destroy.candidato', candidato));
                }
            }
        },
    })
</script>